/** Shared joins for delivery-point location (synced catalog or legacy lugares/barrios). */

export const PUNTO_ENTREGA_LOCATION_FROM_SQL = `
  FROM punto_entrega pe
  LEFT JOIN puntos_entrega_catalogo pec ON pec.id = pe.lugar_id AND pe.lugar_origen = 'catalogo'
  LEFT JOIN lugares l ON l.id = pe.lugar_id AND pe.lugar_origen = 'legacy'
  LEFT JOIN barrios b ON b.id = l.barrio_id
  LEFT JOIN comunas c ON c.id = COALESCE(pec.comuna_id, b.comuna_id)`;

export const PUNTO_ENTREGA_LUGAR_NOMBRE_EXPR = 'COALESCE(pec.nombre, l.nombre)';

export const PUNTO_ENTREGA_BARRIO_NOMBRE_EXPR = "COALESCE(b.nombre, '')";
